.backdrop {
  position: fixed; inset: 0;
  background: rgba(4, 6, 10, 0.7);
  backdrop-filter: blur(8px);
  display: flex; align-items: center; justify-content: center;
  z-index: 60;
  animation: fade var(--dur-fast) var(--ease);
}
@keyframes fade { from { opacity: 0; } to { opacity: 1; } }

.card {
  background: var(--bg-elevated);
  border: 1px solid var(--border-strong);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-height: 85vh;
  display: flex; flex-direction: column;
  overflow: hidden;
  animation: pop var(--dur-mid) var(--ease);
}
.size-sm { max-width: 420px; }
.size-md { max-width: 560px; }
.size-lg { max-width: 720px; }
@keyframes pop { from { transform: translateY(8px) scale(0.98); opacity: 0; } to { transform: none; opacity: 1; } }

.header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
}
.header h2 { margin: 0; font-size: var(--fs-lg); }

.close {
  width: 32px; height: 32px;
  display: flex; align-items: center; justify-content: center;
  color: var(--text-secondary); border-radius: var(--r-sm);
}
.close:hover { background: var(--bg-elevated-2); color: var(--text-primary); }

.body { padding: 20px; overflow: auto; }
.footer { padding: 14px 20px; border-top: 1px solid var(--border); display: flex; gap: 8px; justify-content: flex-end; }
